import i18n from "@/i18n";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    language: "en",
    sidebar: {
      minimized: false
    },
    pageSize: 10,
    pageSizeMember: 10,
    pageSizeCms: 10,
    pageSizeCampaign: 10,
    pageSizeRescueFund: 10,
    pageSizeMemberLabel: 10,
    pageSizePromo: 10,
    pageSizeTicket: 10,
    pageSizeBank: 10,
    pageSizeBankMember: 10,
    pageSizeGameNameExclude: 10,
    pageSizeMemberReport: 10,
    pageSizeGameResult: 10,
    pageSizeMemberLog: 10,
    pageSizeAds: 10,
    utmPageSize: 10,
    mbLabelPageSize: 10,
    mbLabelPageSizeOptions: [10, 20, 50, 100, 500, 1000],
    pageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000],
    utmPageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000],
    accessList: ["account", "report"],
  },
  mutations: {
    updateLanguage(state, payload) {
      state.language = payload;
    },
    updateSidebarMinimized(state, payload) {
      state.sidebar.minimized = payload;
    },
    updatePageSize(state, payload) {
      state.pageSize = payload;
    },
    updatePageSizeMember(state, payload) {
      state.pageSizeMember = payload;
    },
    updatePageSizeCms(state, payload) {
      state.pageSizeCms = payload;
    },
    updatePageSizeCampaign(state, payload) {
      state.pageSizeCampaign = payload;
    },
    updatePageSizeRescueFund(state, payload) {
      state.pageSizeRescueFund = payload;
    },
    updatePageSizeMemberLabel(state, payload) {
      state.pageSizeMemberLabel = payload;
    },
    updatePageSizePromo(state, payload) {
      state.pageSizePromo = payload;
    },
    updatePageSizeTicket(state, payload) {
      state.pageSizeTicket = payload;
    },
    updatePageSizeMemberReport(state, payload) {
      state.pageSizeMemberReport = payload;
    },
    updatePageSizeGameResult(state, payload) {
      state.pageSizeGameResult = payload;
    },
    updatePageSizeMemberLog(state, payload) {
      state.pageSizeMemberLog = payload;
    },
    updateUTMPageSize(state, payload) {
      state.utmPageSize = payload;
    },
    updateMbLabelPageSize(state, payload) {
      state.mbLabelPageSize = payload;
    },
    updatePageSizeBankMember(state, payload) {
      state.pageSizeBankMember = payload;
    },
    updatePageSizeBank(state, payload) {
      state.pageSizeBank = payload;
    },
    updatePageSizeGameNameExclude(state, payload) {
      state.pageSizeGameNameExclude = payload;
    },
    updateAdsPageSize(state, payload) {
      state.pageSizeAds = payload;
    },
  },
  actions: {
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    },
    setSidebarMinimized(context, payload) {
      context.commit("updateSidebarMinimized", payload);
    },
    setPageSize(context, payload) {
      context.commit("updatePageSize", payload);
    },
    setPageSizeMember(context, payload) {
      context.commit("updatePageSizeMember", payload);
    },
    setPageSizeCms(context, payload) {
      context.commit("updatePageSizeCms", payload);
    },
    setPageSizeCampaign(context, payload) {
      context.commit("updatePageSizeCampaign", payload);
    },
    setPageSizeRescueFund(context, payload) {
      context.commit("updatePageSizeRescueFund", payload);
    },
    setPageSizeMemberLabel(context, payload) {
      context.commit("updatePageSizeMemberLabel", payload);
    },
    setPageSizePromo(context, payload) {
      context.commit("updatePageSizePromo", payload);
    },
    setPageSizeTicket(context, payload) {
      context.commit("updatePageSizeTicket", payload);
    },
    setPageSizeMemberReport(context, payload) {
      context.commit("updatePageSizeMemberReport", payload);
    },
    setPageSizeGameResult(context, payload) {
      context.commit("updatePageSizeGameResult", payload);
    },
    setPageSizeMemberLog(context, payload) {
      context.commit("updatePageSizeMemberLog", payload);
    },
    setUTMPageSize(context, payload) {
      context.commit("updateUTMPageSize", payload);
    },
    setMbLabelPageSize(context, payload) {
      context.commit("updateMbLabelPageSize", payload);
    },
    setPageSizeBankMember(context, payload) {
      context.commit("updatePageSizeBankMember", payload);
    },
    setPageSizeBank(context, payload) {
      context.commit("updatePageSizeBank", payload);
    },
    setPageSizeGameNameExclude(context, payload) {
      context.commit("updatePageSizeGameNameExclude", payload);
    },
    setOpLabelPageSize(context, payload) {
      context.commit("updateOpLabelPageSize", payload);
    },
    setAdsPageSize(context, payload) {
      context.commit("updateAdsPageSize", payload);
    },
  }
};
